import React, { useContext } from 'react';
import {
  StyleSheet,
  Text,
  View,
  Alert,
  ScrollView,
  TouchableOpacity,
  Image,
} from 'react-native';
import { AuthContext } from '../Contexts/ContextUsuario';
import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyCO6-LV-_CYfLDFU7pAmGkF6kGVGc9QhGg",
  authDomain: "fichavirtualgesf.firebaseapp.com",
  databaseURL: "https://fichavirtualgesf-default-rtdb.firebaseio.com",
  projectId: "fichavirtualgesf",
  storageBucket: "fichavirtualgesf.appspot.com",
  messagingSenderId: "686082842306",
  appId: "1:686082842306:web:67cc953e6226faab38e55b"
};
// Inicializar o Firebase
var app = firebase.initializeApp(firebaseConfig);
var db = app.database();
var auth = app.auth();

const ButtonChangePage = ({ PaginaCarrinho, PaginaInicio, PaginaSobre}) => {
  return (
    <View style={Style.ButtonsMenu}>
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaCarrinho}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330271288852490/IconeCarrinho.PNG'}}
        />
      </TouchableOpacity>
      </View>

      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaInicio}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330274862137354/IconeCasa.PNG'}}
        />
      </TouchableOpacity>
      </View>
      
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaSobre}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811755835994275860/aboutIcon.PNG'}}
        />
      </TouchableOpacity>

      </View>
    </View>
  );
};

const TelaPerfil = (props) => {
  const { state, actions } = useContext(AuthContext);
  var n_pedidos = state.user.numpedido
  n_pedidos = n_pedidos.join(', ');
  function PaginaCarrinho() {
    props.navigation.navigate('CARRINHO');
  }

  function PaginaInicio() {
    props.navigation.navigate('PAGINA INICIAL');
  }
  function PaginaSobre() {
    props.navigation.navigate('SOBRE');
  }

  function handleDelete() {
    if(window.confirm("Tem certeza que deseja deletar sua conta?\nESSA AÇÃO É IRREVERSÍVEL!")) {
      auth.currentUser.delete().then(() => {
        alert("Conta deletada com sucesso!");
        window.location.reload();
      }).catch(error => {
        alert(```Ocorreu um erro ao deletar sua conta: ${error}\nContate o suporte```);
      })
    }
  }

  return (

<View style={{
      backgroundColor: 'rgba(179, 179, 179, 255)',
      width: '100%',
    height: '100%',
    }}>

      <View style={Style.Cabeçalho}>

      <ButtonChangePage
          PaginaCarrinho={PaginaCarrinho}
          PaginaInicio={PaginaInicio}
          PaginaSobre={PaginaSobre}
          
        />
        <View style={{
          flexDirection: 'row-reverse',
          marginStart: 15,
        }}>
          <Image
            style={Style.CantinaSantaClara}
            source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
          />
        </View>
      </View>
      
      
      <Text style={Style.informações}>Usuário: {state.user.name} </Text>
      <Text style={Style.informações}>Saldo: R$ {state.user.saldo} </Text>
      <Text style={Style.informações}>Pedidos ativos: {n_pedidos} </Text>

      
      <TouchableOpacity
            style={Style.ButtonDelete}
        onPress={handleDelete}>

            <Text style={Style.ButtonDeleteText}> Excluir usuário </Text>
          </TouchableOpacity>

      </View>

      
  );
}
const Style = StyleSheet.create({
  //Pagina inicial --> Cardapio
  botões: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    marginHorizontal: 20,
    width: 150,

    marginTop: 10,
  },

  logo: {
    height: 20,
    width: 20,
  },

  ButtonDelete: {
    marginTop: 20,
    marginBottom: 50,
  },

  ButtonDeleteText: {
    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 13,

    color: 'rgba(255, 255, 255, 255)',
  },

  botão: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 20,
    marginTop: 10,
    marginHorizontal: 70,
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  informações:{
    flexDirection:'row',
    justifyContent:'center',

    width: '95%',
    height: 60,

    padding: 20,

    marginStart: '2.5%',
    marginTop: 25,

    backgroundColor: '#FFFFFF',

    borderRadius: 50,
    borderWidth: 1,
    borderColor: 'rgba(0, 58, 109, 255)',
  },

  CantinaSantaClara: {
    
    width: 150,
    height: 85,
  },

  Cabeçalho: {
    flexDirection: 'column-reverse',
    width: '100%',
    height: 170,

    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  ButtonsMenu: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    width: '100%',
    height: 80,

    marginTop: -10,
  },

  ButtonMenu: {
    
    flexDirection: 'row',
        

    backgroundColor: 'rgba(255, 255, 255, 255)',

    borderRadius: 50,

    padding: 7,

    marginBottom: 30,
    marginTop: 30,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  IconMenu: {
    height: 20,
    width: 20,
  },
});

export default TelaPerfil;
